<template>
  <svg
    class="icon-case-page-product-categories"
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    width="500.000000pt"
    height="500.000000pt"
    viewBox="0 0 500.000000 500.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
      <path
        d="M2410 3817 c-91 -26 -173 -103 -206 -194 -18 -53 -17 -160 3 -219 22 -64 113 -157 171 -175 l42 -12 0 -209 0 -208 -620 0 -621 0 -24 -25 -25 -24 0 -353 -1 -353 -51 -30 c-155 -91 -147 -334 14 -416 99 -50 205 -34 284 45 78 79 95 185 45 284 -23 46 -81 99 -116 108 l-25 6 0 304 0 304 570 0 570 0 0 -304 0 -304 -29 -12 c-113 -46 -164 -203 -107 -326 81 -175 342 -176 432 -2 22 43 29 129 14 183 -16 56 -79 130 -125 147 l-35 12 0 303 0 303 575 0 575 0 0 -300 0 -300 -37 -19 c-122 -63 -168 -206 -107 -329 82 -166 321 -176 418 -18 35 56 46 149 26 211 -16 48 -72 111 -122 136 l-38 19 0 360 0 359 -22 15 c-20 14 -98 16 -645 16 l-623 0 0 204 0 203 65 32 c143 71 208 226 158 381 -21 65 -89 143 -155 176 -60 31 -162 40 -228 21z m160 -157 c50 -25 81 -71 88 -126 6 -54 -11 -95 -54 -134 -61 -53 -137 -57 -202 -11 -75 53 -83 181 -16 243 56 50 121 60 184 28z"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.icon-case-page-product-categories {
  display: block;
  height: 46px;
  width: 46px;
}
</style>
